import React from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DraftsOutlinedIcon from '@mui/icons-material/DraftsOutlined';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';

const ThreeDotMenu = ({ rowId, onAction }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuClick = (action) => {
    onAction(rowId, 'action', action); // Update state in parent
    handleClose();
  };

  return (
    <>
      <IconButton size="small" onClick={handleClick}>
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {/* <MenuItem onClick={() => handleMenuClick('Edit')}>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Edit</ListItemText>
        </MenuItem> */}
        <MenuItem onClick={() => handleMenuClick('View')}>
          <ListItemIcon sx={{ minWidth: 32 }}>
            <VisibilityOutlinedIcon sx={{ fontSize: 20 }} />
          </ListItemIcon>
          <ListItemText primary="View" primaryTypographyProps={{ fontSize: 14 }} />
        </MenuItem>
        {/* <MenuItem onClick={() => handleMenuClick('Delete')}>
          <ListItemIcon sx={{ minWidth: 32 }}>
            <DeleteOutlineIcon sx={{ fontSize: 20 }} />
          </ListItemIcon>
          <ListItemText primary="Delete" primaryTypographyProps={{ fontSize: 14 }} />
        </MenuItem> */}
        <MenuItem onClick={() => handleMenuClick('Send to draft')}>
          <ListItemIcon sx={{ minWidth: 32 }}>
            <DraftsOutlinedIcon sx={{ fontSize: 20 }} />
          </ListItemIcon>
          <ListItemText primary="Send to draft" primaryTypographyProps={{ fontSize: 14 }} />
        </MenuItem>
        <MenuItem onClick={() => handleMenuClick('Deactivated')}>
          <ListItemIcon sx={{ minWidth: 32 }}>
            <BlockOutlinedIcon sx={{ fontSize: 20 }} />
          </ListItemIcon>
          <ListItemText primary="Deactivated" primaryTypographyProps={{ fontSize: 14 }} />
        </MenuItem> 
      </Menu>
    </>
  );
};

export default ThreeDotMenu;
